import * as React from 'react';

const ContactIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
    <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.0001 3.33317V12.6665H4.89341L3.33341 14.2265V3.33317H18.0001ZM19.3334 0.666504H2.00008C1.26675 0.666504 0.666748 1.2665 0.666748 1.99984V20.6665L6.00008 15.3332H19.3334C20.0667 15.3332 20.6667 14.7332 20.6667 13.9998V1.99984C20.6667 1.2665 20.0667 0.666504 19.3334 0.666504ZM26.0001 5.99984H23.3334V17.9998H6.00008V20.6665C6.00008 21.3998 6.60008 21.9998 7.33342 21.9998H22.0001L27.3334 27.3332V7.33317C27.3334 6.59984 26.7334 5.99984 26.0001 5.99984Z"
            fill="#1F2123"
        />
    </svg>
);
export default ContactIcon;
